import { Component, OnInit } from "@angular/core";
import { AgGridEvent } from "ag-grid-community";
import * as moment from 'moment';
import { BankPortalService } from "../../../web-api-client";
@Component({
    selector: 'transaction-report',
    templateUrl: './transaction-report.component.html',
})

export class TransactionReportComponent implements OnInit {
    columnDefs: any[] = [];
    private gridApi;
    private gridColumnApi;
    columns: any[] = [];
    TransactionReport = [];
    public changesSavedCallback!: () => void;
    public changesFailedCallback!: () => void;
    public changesCancelledCallback!: () => void;
    IsDateFilter = false;
    rows: any;
    filteredData: any;
    rowsCache: any;
  quickSearchValue: any;
  api: any;
  columnApi: any;


    constructor(private bankPortalService: BankPortalService,) {
    }

    ngOnInit() {

        this.columnDefs = [
            { headerName: 'Settlement Date', field: 'settlementDate', width: 180, suppressSizeToFit: true },
            { headerName: 'Transaction Date', field: 'trxDate', width: 180, suppressSizeToFit: true },
            { headerName: 'Merchant Number', field: 'merchantNumber', width: 180, suppressSizeToFit: true },
            { headerName: 'Terminal Number', field: 'terminalNumber', width: 180, suppressSizeToFit: true },
            { headerName: 'Card Mask', field: 'cardMask', width: 180, suppressSizeToFit: true },
            { headerName: 'RRN', field: 'rrn', width: 120, suppressSizeToFit: true },
            { headerName: 'Card Type', field: 'cardType', width: 140, suppressSizeToFit: true },
            { headerName: 'Network', field: 'network', width: 100, suppressSizeToFit: true },
            { headerName: 'Merchant Name', field: 'merchantName', width: 180, suppressSizeToFit: true },
            { headerName: 'Merchant Account', field: 'merchantAccount', width: 180, suppressSizeToFit: true },
            { headerName: 'Transaction Amount', field: 'trxAmount', width: 180, suppressSizeToFit: true },
            { headerName: 'MSC Rate', field: 'mscRate', width: 100, suppressSizeToFit: true },
            { headerName: 'MSC Amount', field: 'mscAmount', width: 160, suppressSizeToFit: true },
            { headerName: 'Settlement Amount', field: 'settlementAmount', width: 160, suppressSizeToFit: true },
        ];

        //this.loadData();
        this.loadTransactionReport();
    }
    public setReturnValue(dateRange) {
        this.IsDateFilter = true;
        let startDate = dateRange['from'];
        let endDate = dateRange['to'];
        let sDate = moment(startDate);
        let eDate = moment(endDate);
        //let result = this.rows.filter(function (posHistory, index, posHistorys) {
        //    if (moment(posHistory.deployDate) >= sDate && moment(posHistory.deployDate) <= eDate) {
        //        (<any>posHistory).index = index + 1;
        //        return posHistory;
        //    }
        //    else {
        //        return false;
        //    }
        //});
        //return this.rows = result;

        const result = this.rows.filter(obj => moment(obj.printedDate) >= sDate && moment(obj.printedDate) <= eDate);
        return this.filteredData = result;

    }
    public onBtExport() {

        this.gridApi.exportDataAsCsv();
    }
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        // this.alertService.stopLoadingMessage();
        //this.poshistoryService.getPosHistoryInfo().subscribe(data => {
        //    params.api.setRowData(data);
        //});
        params.api.setRowData(this.rows);
        this.api = params.api;
        this.columnApi = params.columnApi;
    }

    onModelUpdated() {
      setTimeout(() => { this.gridColumnApi.autoSizeAllColumns() });
    }
    onGridFilterReady(params) {
        this.gridApi = params.api;
        // this.alertService.stopLoadingMessage();
        params.api.setRowData(this.filteredData);
    }

    onDataLoadFailed(error: any) {
        // this.alertService.stopLoadingMessage();


        //this.alertService.showStickyMessage("Load Error", `Unable to retrieve users from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
        //    MessageSeverity.error, error);
    }
    loadTransactionReport() {
        this.bankPortalService.bankPortal_GetTransactionDetails().subscribe(res => {
            this.rows = res;
        },
         error => this.unSuccess(error));

      }


      unSuccess(error: any) {
        // this.notify.showError("Error", "Error !!");
      }


    onRowClicked(event){

    }

    onFilterChanged(e: AgGridEvent){
      e.api.refreshCells();
  }

    onQuickFilterChanged(){
      this.api.setQuickFilter(this.quickSearchValue)
    }
}
